import axiosInstance from "../api/api";

const ReviewService = {
    list: function () {
        return axiosInstance({
            url: "/api/review/",
            method: "GET",
        });
    },
    fetchSettingForUser: function () {
        return axiosInstance({
            url: "/api/review/setting",
            method: "GET",
        });
    },
    listByTenant: function () {
        return axiosInstance({
            url: "/api/review/tenant",
            method: "GET",
        });
    },
    fetch: function (uniqueId) {
        return axiosInstance({
            url: `/api/review/${uniqueId}`,
            method: "GET",
        });
    },
    userReviewDetails: function (uniqueId) {
        let url = `/api/review/userReviewDetails/${uniqueId}`
        if(uniqueId === undefined) {
            url = `/api/review/userReviewDetails/`
        }
        return axiosInstance({
            url: url,
            method: "GET",
        });
    },
    unansweredContacts: function () {
        return axiosInstance({
            url: `/api/review/unanswered/`,
            method: "GET",
        });
    },
    fetchSurveyDetails: function (uniqueId) {
        return axiosInstance({
            url: `/api/review/surveydetails/${uniqueId}`,
            method: "GET",
        });
    },
    xareviewData: function (uniqueId) {
        return axiosInstance({
            url: `/api/review/xareview`,
            method: "GET",
        });
    },
    delete: function (uniqueId) {
        return axiosInstance({
            url: `/api/review/${uniqueId}`,
            method: "DELETE",
        });
    },
    createSetting: function (formData) {
        return axiosInstance({
            url: `/api/review/setting`,
            method: "POST",
            data: formData,
        });
    },
    createReviewCampaign: function (formData) {
        return axiosInstance({
            url: `/api/review/campaign`,
            method: "POST",
            data: formData,
        });
    },
    submitReviewAnswers: function (formData) {
        return axiosInstance({
            url: `/api/review/submit`,
            method: "POST",
            data: formData,
        });
    },
    update: function (formData) {
        return axiosInstance({
            url: `/api/review/`,
            method: "PATCH",
            data: formData,
        });
    },
};
export default ReviewService;
